import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HttpGenericService } from 'src/app/services/http-generic.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { TipoDeMensajeSwal } from 'src/app/models/enums/tipo-de-mensaje-swal';

@Component({
  selector: 'app-cambiar-contrasena',
  templateUrl: './cambiar-contrasena.component.html',
  styleUrls: ['./cambiar-contrasena.component.css']
})
export class CambiarContrasenaComponent implements OnInit {

  idUsuario: number;
  contrasena: string;
  confirmarContrasena: string;
  procesando: boolean = false;

  constructor(
    public bsModalRef: BsModalRef,
    private httpGenerico: HttpGenericService,
    private swal: SweetAlertService) { }

  ngOnInit() {
  }

  guardar() {
    this.procesando = true;

    let modelo = {
      idUsuario: this.idUsuario,
      contrasena: this.contrasena,
      confirmarContrasena: this.confirmarContrasena
    }

    this.httpGenerico.post('usuarios/password', modelo)
      .subscribe(data => {
        this.procesando = false;
        this.swal.mostrar(TipoDeMensajeSwal.Success, 'Contraseña cambiada exitosamente', '');
        this.bsModalRef.content.cambioContrasena = true;
        this.bsModalRef.hide();
      }, error => {
        this.procesando = false;
        if(error.status == 400) {
          this.swal.mostrar(TipoDeMensajeSwal.Warning, 'Verificar', 'Las contraseñas ingresadas no son iguales');
        }
        else {
          this.swal.mostrar(TipoDeMensajeSwal.Error, 'Error', 'Ha ocurrido un error, intente mas tarde');
        }
      });
  }

}
